<template>
  <table class="extension-details-section">
    <tbody>
      <tr v-if="rewardLoadError">
        <td colspan="2" class="error-label text-center">{{rewardLoadError}}</td>
      </tr>
      <tr v-if="!isInstantPoints && extensionDetails.name !== 'any link'">
        <td>{{extensionDetails.name}}</td>
        <td class="text-right">️{{extensionNameValue}}</td>
      </tr>
      <template v-if="extensionDetails.name === 'any link'" v-for="(anyLink, index) in extensionNameValue">
        <template v-if="index === 0">
          <tr>
            <td>{{extensionDetails.name}}</td>
            <td class="text-right">️{{anyLink.url}}</td>
          </tr>
        </template>
        <template v-else>
          <tr>
            <td colspan="2" class="text-right">️{{anyLink.url}}</td>
          </tr>
        </template>
      </template>
      <template v-if="isOffer">
        <reward-attachments :rewardId="rewardId"
                            :rewardOwnerId="extension.ownerId"
                            :rewardOwnerType="extension.ownerType"
                            @setRewardAttachment="setRewardAttachment"></reward-attachments>
        <tr class="reward-offer-type">
          <td>offer type</td>
          <td class="text-right">{{offerType}}</td>
        </tr>
        <template v-if="isBonusReward">
          <tr class="reward-bonus-points">
            <td>bonus points</td>
            <td class="text-right">{{bonusPoints}}</td>
          </tr>
          <tr class="reward-min-purchase">
            <td>min purchase amount</td>
            <td class="text-right">{{minPurchaseAmount}}</td>
          </tr>
        </template>
        <tr v-if="isInstantPoints" class="reward-num-uses">
          <td>instant points</td>
          <td class="text-right">{{rewardPoints}}</td>
        </tr>
        <template v-if="!isInstantPoints">
          <tr class="reward-num-uses">
            <td># of uses</td>
            <td class="text-right">{{maxRedemptions}}</td>
          </tr>
          <tr class="reward-expiration">
            <td>{{expirationLabel}}</td>
            <td class="text-right">{{expirationDate}}</td>
          </tr>
        </template>
        <tr class="reward-offers-issued" v-if="isOffer">
          <td>offers issued</td>
          <td class="text-right">{{offersIssued}}</td>
        </tr>
        <tr class="reward-preload-image">
          <td>preload image</td>
          <td class="text-right">
            <img v-if="preloadThumb" class="thumbnail" :src="preloadThumb" />
            <span v-else>none</span>
          </td>
        </tr>
        <tr v-if="reward && !reward.type" class="reward-voucher-image">
          <td>voucher image</td>
          <td class="text-right">
            <template v-if="couponThumb.length > 0" v-for="(thumb) in couponThumb">
            <img  class="thumbnail" :src="thumb" />
            </template>
            <span v-else>none</span>
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { utcToZonedTime } from 'date-fns-tz'
  import { format } from 'date-fns'
  import LoadRewardMixin from '../../mixins/LoadRewardMixin'
  import RewardAttachments from '../Rewards/RewardAttachments'
  import moment from "moment"

  export default {
    props: {
      extension: Object,
      extensionType: Number,
      isOffer: Boolean,
      rewardId: Number,
    },

    name: 'ExtensionDetails',

    components: {
      RewardAttachments,
    },

    mixins: [LoadRewardMixin],

    data() {
      return {
        bonusType: 'loading',
        bonusValue: 0,
        couponThumb: Array,
        expirationDate: 'loading',
        extensionDetails: null,
        isBonusReward: false,
        isInstantPoints: false,
        maxRedemptions: 'loading',
        minPurchaseAmount: 0,
        offerType: 'loading',
        offersIssued: null,
        preloadThumb: null,
        reward: null,
        rewardLoadError: null,
      }
    },

    methods: {
      configureOfferType(offerType) {
        let offerTypeName = 'digital voucher'
        switch (offerType) {
          case 'BonusReward':
            offerTypeName = 'bonus points'
            break
          case 'InstantReward':
            offerTypeName = 'instant points'
            break
        }
        this.$emit('updateRewardType', offerTypeName)
        return offerTypeName
      },

      configureThumbText(thumb) {
        if (thumb === 'loading') { return 'loading' }
        if (!thumb) { return 'none' }
      },

      setRewardData(data) {
        const minPurchase = data.min_purchase_amount

        this.bonusType = data.bonus_type
        this.bonusValue = data.bonus_value
        this.offersIssued = data.offers_issued
        if (this.isAutoCampaign) {
          this.expirationDate = this.calculateDaysFromEpoch(data.expiry_days)
        } else {
          this.expirationDate = data.expiration_date ? format(utcToZonedTime(data.expiration_date, this.merchantTimeZone), "MM/dd/yy") : "--"
        }
        this.isBonusReward = data.type === 'BonusReward'
        this.isInstantPoints = data.type === 'InstantReward'
        this.maxRedemptions = data.max_redemptions === -1 ? 'unlimited' : data.max_redemptions
        this.minPurchaseAmount = minPurchase > 0 ? `$${parseInt(minPurchase).toFixed(1)}` : minPurchase
        this.offerType = this.configureOfferType(data.type)
        this.reward = data
      },

      setRewardLoadError(error) {
        this.rewardLoadError = error
      },

      setRewardAttachment(attachmentType, attachment) {
        if (attachmentType === 'coupon') {
          const thumbSrc = attachment.map(coupon => { console.log(coupon.thumb);  return coupon.thumb })
          this.couponThumb = thumbSrc
          return this.couponThumb
        }
        if (attachmentType === 'preload') {
          const thumbSrc = attachment ? attachment.thumb : null
          return this.preloadThumb = thumbSrc
        }
      },

      calculateDaysFromEpoch(expiry) {
        if(expiry){
          const epochTime = moment("01/01/1970", "MM/DD/YYYY")
          const diff = epochTime.diff(expiry, 'days')
          return diff < 2 ? `${diff} day` : `${diff} days`
        }else{
          return '--'
        }
      }
    },

    created() {
      this.extensionDetails = this.extension
      if (this.isOffer) { this.loadReward() }
    },

    computed: {
      bonusPoints: function () {
        const bonusType = this.bonusType === 'add' ? '+' : 'x'
        return this.bonusType ? `${bonusType} ${this.bonusValue}` : 'loading'
      },

      extensionNameValue: function () {
        const details = this.extensionDetails
        return details?.value || this.reward?.item_name
      },

      rewardPoints: function () {
        const points = Number(this.bonusValue)
        return points.toLocaleString('en-US', {minimumFractionDigits: 2})
      },

      isAutoCampaign: function () {
        return this.extensionDetails.ownerType === "AutoCampaignMessage"
      },

      expirationLabel: function (){
        return this.isAutoCampaign ? 'offer expires after': 'expiration'
      },
      ...mapGetters(["merchantTimeZone"])
    },
  }
</script>
